import React from 'react';
import Text from '@ingka/text';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import Loader from './Loader';

const StyledText = styled(Text)`
  &&& {
    text-align: center;
  }
`;
export interface LoadingProps {
  title: string;
}

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 272px;
`;

const Loading: React.FC<LoadingProps> = ({ title }) => {
  const { t } = useTranslation();
  return (
    <LoadingContainer>
      <Loader />
      <StyledText tagName="p">{title}</StyledText>
      <StyledText tagName="p">{t('components.loading.description')}</StyledText>
    </LoadingContainer>
  );
};

export default Loading;
